import { render, staticRenderFns } from "./plUser.vue?vue&type=template&id=abea6166&scoped=true&"
import script from "./plUser.vue?vue&type=script&lang=js&"
export * from "./plUser.vue?vue&type=script&lang=js&"
import style0 from "./plUser.vue?vue&type=style&index=0&id=abea6166&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abea6166",
  null
  
)

export default component.exports